export const sortCostCenters = <T extends { name: string }[]>(
  costCenters: T,
) => {
  return [...costCenters].sort((a, b) =>
    a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
  );
};
